export const environment = {
  baseUrl: 'https://api.ristoclick.com',
  matomoId: 3,
  tokenUrl: 'https://auth.gojodigital.com/realms/risto-click-public/protocol/openid-connect/token',
  showCookieModal: false,
  publicUser: 'public-user',
  publicUserPassword: 'public-user'
};
